import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

/**
 * Inactivity warning modal overlay.
 * Rendered by the root `App` component when `SessionTimeoutService.showWarning` is `true`.
 * Emits `staySignedIn` or `signOut` for the parent to delegate to `SessionTimeoutService`.
 */
@Component({
  selector: 'app-session-timeout-modal',
  imports: [TranslocoModule],
  templateUrl: './session-timeout-modal.component.html',
  styleUrl: './session-timeout-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionTimeoutModalComponent {
  /** Emitted when the user clicks "Stay Signed In". */
  readonly staySignedIn = output<void>();

  /** Emitted when the user clicks "Sign Out". */
  readonly signOut = output<void>();

  /** Notifies the parent to reset the session timer. */
  onStaySignedIn(): void {
    this.staySignedIn.emit();
  }

  /** Notifies the parent to perform an immediate logout. */
  onSignOut(): void {
    this.signOut.emit();
  }
}
